import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './PalletTransactions.frontend.types'

@Injectable({ providedIn: 'root' })
export class PalletTransactions_is_pallet_transaction_deletableService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { id?: number, project_id?: number, shipment_id?: number, carrier_id?: number, account_id?: number, pallet_class_id?: number, reference?: string, notes?: string, amount?: number }): Promise<{ valid?: boolean, exceptions?: string }> 
  {
    let url = `${environment.backendUrl}api/PalletTransactions/functions/is_pallet_transaction_deletable`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

